import React, { useState } from 'react'
import InputField from '../../../atoms/InputField'
import Text from '../../../atoms/Text'
import { FaRegCircle, FaCheckCircle, FaCheckSquare } from 'react-icons/fa'
import { MdCheckBox, MdCheckBoxOutlineBlank } from 'react-icons/md'
import { IoMdInformationCircleOutline as InfoIcon } from 'react-icons/io'

import { ReactComponent as ArrowRight } from '../../../../assets/icons/right_arrow.svg'
import questionIcon from '../../../../assets/icons/question_avatar.svg'
import Button from '../../../atoms/GoodFlipButton'

const Question = (props) => {
  const { answers, question, onSubmitAnswer, showQuestions = true } = props

  const [inputValue, setInputValue] = useState('')
  const [selectedOpt, setSelectedOpt] = useState(
    Array.isArray(question?.answers) ? question?.answers : [],
  )

  const handleInput = (event) => {
    setInputValue(event.target.value)
  }

  return (
    <div className="overflow-hidden">
      {showQuestions && (
        <div className="flex gap-3 items-start mb-2">
          <img src={questionIcon} alt="ph" className="h-[32px] w-[32px]" />
          <div className="w-full mx-auto pr-4">
            <Text
              tag="p"
              variant="title"
              className="whitespace-normal break-words"
              size="medium"
            >
              {question?.question.replace(/\//g, ' / ')}
            </Text>
          </div>
        </div>
      )}
      <div>
        {question?.note && (
          <div className="text-text-disabled mt-4 mb-2 flex gap-1">
            <div className="h-5 w-5">
              <InfoIcon size={18} />
            </div>
            <Text tag="p" variant="body" size="medium">
              {question.note}
            </Text>
          </div>
        )}
        {question?.dataType ? (
          <div className="mb-6">
            {question.dataType === 'multi-select' ? (
              <div className="py-3 flex gap-3 flex-wrap items-center">
                {question?.options?.map((opt) => (
                  <label
                    key={`${opt?.id}__${opt.score}`}
                    className="cursor-pointer"
                  >
                    <input
                      type="checkbox"
                      name={question.id.toString()}
                      value={opt.label}
                      checked={selectedOpt?.includes(opt.value)}
                      onChange={() =>
                        setSelectedOpt((prev) =>
                          prev.includes(opt.value)
                            ? prev.filter((val) => val !== opt.value)
                            : [...prev, opt.value],
                        )
                      }
                      className="sr-only peer"
                    />
                    <div className="flex items-center gap-2 cursor-pointer border rounded-full px-4 py-2.5 text-gray-700 transition-colors peer-checked:bg-background-brand-teal peer-checked:text-white">
                      {selectedOpt?.includes(opt.value) ? (
                        <MdCheckBox />
                      ) : (
                        <MdCheckBoxOutlineBlank />
                      )}
                      <Text size="medium" variant="label" tag="p">
                        {opt.label}
                      </Text>
                    </div>
                  </label>
                ))}
              </div>
            ) : (
              <InputField
                type={'number'}
                placeholder="Enter your answer"
                className="border border-gray-300 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-teal-500"
                onChange={handleInput}
                value={inputValue}
                label={question?.label || ''}
                autoFocus={true}
              />
            )}
          </div>
        ) : question?.options?.length > 0 ? (
          <div className="py-3 flex gap-3 flex-wrap items-center">
            {question?.options?.map((opt) => (
              <label
                key={`${opt?.id}__${opt.score}`}
                className="cursor-pointer"
              >
                <input
                  type="radio"
                  name={question.id.toString()}
                  value={opt.label}
                  checked={answers?.value === opt.label}
                  onChange={() =>
                    onSubmitAnswer(question.id, { ...opt, value: opt.label })
                  }
                  className="sr-only peer"
                />
                <div className="flex items-center gap-2 cursor-pointer border rounded-full px-4 py-2.5 text-gray-700 transition-colors peer-checked:bg-background-brand-teal peer-checked:text-white">
                  {answers?.score === opt.score ? (
                    <FaCheckCircle />
                  ) : (
                    <FaRegCircle />
                  )}
                  <Text size="medium" variant="label" tag="p">
                    {opt.label}
                  </Text>
                </div>
              </label>
            ))}
          </div>
        ) : null}
      </div>
      {question?.nextButtonEnabled && (
        <div className="flex justify-center">
          <Button
            title="Next"
            type="goodflip_primary"
            onClick={() => {
              onSubmitAnswer(
                question.id,
                question?.dataType === 'multi-select'
                  ? selectedOpt
                  : { value: inputValue },
              )
              setSelectedOpt([])
              setInputValue('')
            }}
            disabled={
              question?.dataType === 'multi-select'
                ? !selectedOpt.length
                : !inputValue
            }
            className="!mx-0 mb-4 w-3/5 h-8"
            leftIcon={null}
            rightIcon={<ArrowRight />}
          />
        </div>
      )}
    </div>
  )
}

export default Question
